import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MainApp from './MainApp'
import LoginApp from './LoginApp'

import './App.css'

class App extends React.PureComponent {
  render() {
    return this.props.isLoggedIn
      ? <MainApp />
      : <LoginApp />
  }
}

App.propTypes = {
  // Properties

  // Redux State
  isLoggedIn: PropTypes.bool.isRequired

  // Redux Actions

}

export default connect(
  (state) => ({
    isLoggedIn: !_.isNull(state.app.identity.user)
  }),
  (dispatch) => ({

  })
)(App)



// WEBPACK FOOTER //
// ./src/containers/app/App.js